// extracted by mini-css-extract-plugin
export default {"inputContainer":"AlternativeAddress_inputContainer__ZdMJ8"};